import { Directive, Input } from "@angular/core";

import { PostFileMediaType } from "../../../../../shared/enums/campaignPost.enums";

@Directive({
  selector: "[carouselItem]",
})
export class CarouselEditItemDirective {
  @Input() id: number | null = null;
  @Input() image = "";
  @Input() text = "";
  @Input() description = "";
  @Input() link = "";
  @Input() file: any;
  @Input() videoUrl = "";
  @Input({ required: true }) fileType!: PostFileMediaType;
  constructor() {}
}

@Directive({
  selector: ".carousel-item",
})
export class CarouselEditItemElementDirective {}
